import EuFormContainer from 'components/eu/EuFormContainer';

export default function NlMigrationFormPage() {
  const contentfulId = '5fGqBod0fToAENcoEMlj5N'; // Netherlands Form Page
  const country = 'NETHERLANDS';
  return <EuFormContainer contentfulId={contentfulId} country={country} />;
}
